var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.501 55.1673C260.502 47.1652 249.651 42.6684 238.336 42.666H85.3332C74.0173 42.666 63.1648 47.1612 55.1633 55.1628C47.1617 63.1643 42.6665 74.0168 42.6665 85.3327V238.335C42.6689 249.65 47.1657 260.501 55.1678 268.501L240.853 454.186C250.549 463.821 263.664 469.229 277.333 469.229C291.003 469.229 304.117 463.821 313.813 454.186L454.187 313.813C463.822 304.116 469.229 291.002 469.229 277.333C469.229 263.663 463.822 250.549 454.187 240.853",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 170.667C165.891 170.667 170.667 165.892 170.667 160.001C170.667 154.11 165.891 149.334 160 149.334C154.109 149.334 149.333 154.11 149.333 160.001C149.333 165.892 154.109 170.667 160 170.667Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271 146H449",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360 57V235",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagCreate);
export default __webpack_public_path__ + "static/media/tag-create.80d2e828b7b62da5f0e0154774e93447.svg";
export { ForwardRef as ReactComponent };